import RestService from './RestService';

export default class ApiKeys extends RestService {
    constructor(parentService, companyIdOrPartnerId) {
        if (parentService && companyIdOrPartnerId) {
            // Check if parentService is Partners (has baseUrl '/partners')
            if (parentService.baseUrl === '/partners') {
                super(`${parentService.baseUrl}/${companyIdOrPartnerId}/apiKeys`);
            } else {
                // Company API keys
                super(`${parentService.baseUrl}/${companyIdOrPartnerId}/apikeys`);
            }
        } else {
            throw new Error('company or partner ID is required');
        }
    }

    /**
     * Regenerate (roll) API key. Returns new key once; old key is invalidated.
     * @param {number} id - API key id
     * @returns {Promise<{ id, value, maskedValue, ... }>}
     */
    regenerate(id) {
        return this.put(`${this.baseUrl}/${id}/regenerate`, {});
    }
}
